module.exports = __webpack_public_path__ + "media/images/cz5-26083df2397e774038736eb59ddaafc2.svg";